<div class="row">
    <app-cybersocxmenu></app-cybersocxmenu>
</div>
<div class="col-12">
    <div class="row" *ngIf="xdrCase">
        <h2 class="col-12">[{{ xdrCase.socXdrStatus }}] - {{ xdrCase.subject | anonymise }}</h2>
        <app-incident-timeline
            class="col-12 card card-body py-2 mx-2"
            title="Incident state over time"
            [data]="xdrCase.timeline"
        />

        <div class="col-sm-12 col-lg-6 px-2 py-2">
            <section class="pb-4">
                <div class="card card-body">
                    <h3>{{ 'pages.cybersocxdr.dashboard.fieldTitles.incidentInformation' | translate }}</h3>
                    <div class="row">
                        <p class="col-6 font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.incidentUrl' | translate }}
                        </p>
                        <a [href]="xdrCase.incidentUrl" class="col-6">{{ xdrCase.incidentUrl | shortUrl | anonymise }}</a>
                        <hr class="col-12 no-height">

                        <p class="col-6 font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.occured' | translate }}
                        </p>
                        <p class="col-6">{{ xdrCase.createdDate | date:'short' }}</p>
                        <hr class="col-12 no-height">

                        <p class="col-6 font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.severity' | translate }}
                        </p>
                        <div class="col-6">
                            <p
                                class="badge bg-light p-2 px-4 py-1 d-inline"
                                [ngClass]="'P' + xdrCase.severity | lowercase | removeWhiteSpace"
                            >
                                {{ xdrCase.severity | severity | translate }}
                            </p>
                        </div>
                        <hr class="col-12 no-height">

                        <p class="col-6 font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.incidentOwner' | translate }}
                        </p>
                        <p class="col-6">{{ xdrCase.owner | anonymise }}</p>
                        <hr class="col-12 no-height">

                        <p class="col-6 font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.category' | translate }}
                        </p>
                        <p class="col-6">{{ xdrCase.category }}</p>
                        <hr class="col-12 no-height">

                        <p class="col-6 font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.description' | translate }}
                        </p>
                        <p class="col-6">{{ xdrCase.subject | anonymise }}</p>
                        <hr class="col-12 no-height">

                        <p *ngIf="xdrCase.socXdrStatus" class="col-6 font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.status' | translate }}
                        </p>
                        <p *ngIf="xdrCase.socXdrStatus" class="col-6">{{ xdrCase.socXdrStatus }}</p>
                    </div>
                </div>
            </section>

            <section class="card card-body">
                <h3 class="col-12 text-center">
                    {{ 'pages.cybersocxdr.dashboard.fieldTitles.slaFull' | translate }}
                </h3>
                <div *ngIf="xdrCase.notificationSla && xdrCase.investigationSla; else noSla" class="row">
                    <div class="col-6 text-center">
                        <h4 class="font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.slaNotificationTime' | translate }}
                        </h4>
                        <p
                            class="display-3"
                            [ngClass]="{
                                'text-danger': xdrCase.notificationSla > xdrCase.allowedNotificationSla,
                                'text-success': xdrCase.notificationSla <= xdrCase.allowedNotificationSla
                            }"
                        >
                            {{ parseTimeLeft(xdrCase.notificationSla) }}
                        </p>
                    </div>
                    <div class="col-6 text-center">
                        <h4 class="font-weight-bold">
                            {{ 'pages.cybersocxdr.dashboard.fieldTitles.slaInvestigationTime' | translate }}
                        </h4>
                        <p
                            class="display-3"
                            [ngClass]="{
                                'text-danger': xdrCase.investigationSla > xdrCase.allowedInvestigationSla,
                                'text-success': xdrCase.investigationSla <= xdrCase.allowedInvestigationSla
                            }"
                        >
                            {{ parseTimeLeft(xdrCase.investigationSla) }}
                        </p>
                    </div>
                </div>
                <ng-template #noSla>
                    <p class="text-center">
                        {{ 'pages.cybersocxdr.dashboard.noSla' | translate }}
                    </p>
                </ng-template>
            </section>
        </div>

        <div class="col-sm-12 col-lg-6 d-flex px-2 py-2 position-relative">
            <section class="card row card-body">
                <h3>{{ 'pages.cybersocxdr.dashboard.investigation' | translate }}</h3>
                <p id="investigationContent" *ngIf="xdrCase.investigationContent; else noInvest">
                    {{ xdrCase.investigationContent | anonymise }}
                </p>
                <ng-template #noInvest>
                    <img alt="{{ 'pages.cybersocxdr.dashboard.noResults' | translate }}" src="/assets/images/icons/no_data.svg" id="no-data" class="no-data">

                    <p class="text-center no-data-text">
                        {{ 'pages.cybersocxdr.dashboard.noInvestigation' | translate }}
                    </p>
                </ng-template>
            </section>
        </div>

        <section class="col-sm-12 col-lg-6 mb-4 px-2 py-2">
            <app-barovertime
                class="card"
                [data]="categoryHighchartsData"
                [createdFrom]="oldDate"
                [createdTo]="currentDate"
                title="{{'pages.cybersocxdr.charts.preciseCategoryOvertime' | translate: {category: xdrCase.category} }}"
                titleY="{{'pages.cybersocxdr.menu.incidents' | translate }}"
            />
        </section>

        <section class="col-sm-12 col-lg-6 mb-4 px-2 py-2">
            <app-barovertime
                class="card"
                [data]="similarHighchartsData"
                [createdFrom]="oldDate"
                [createdTo]="currentDate"
                title="{{'pages.cybersocxdr.charts.similarOvertime' | translate }}"
                titleY="{{'pages.cybersocxdr.menu.incidents' | translate }}"
            />
        </section>

        <app-microsoccase-list
            title="{{ 'pages.cybersocxdr.menu.similarIncident' | translate }}"
            subtitle="{{ 'pages.cybersocxdr.menu.similarIncidentDesc' | translate }}"
            [loaded]="true"
            [cases]="similarXdrCases"
            [flags]="[]"
            [main]="'false'"
        ></app-microsoccase-list>
    </div>
</div>
